[
  {
    "code": "oulu",
    "label": "Oulu",
    "slug": "oulu",
    "address": "Portinkaarre 1, 90410 Oulu"
  },
  {
    "code": "rovaniemi",
    "label": "Rovaniemi",
    "slug": "rovaniemi",
    "address": "Keskusväylä 7, 96910 Rovaniemi"
  },
  {
    "code": "ranua",
    "label": "Ranua",
    "slug": "ranua",
    "address": "Teeritie 2-4, 97700 Ranua"
  }
]